export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
    id: string;
    type: ToastType;
    title: string;
    message?: string;
    duration?: number;
}

export const TOAST_VARIANTS = {
    success: {
        base: 'bg-green-50 border-green-200 dark:bg-green-900/90 dark:border-green-900',
        icon: 'text-green-500 dark:text-green-400',
        title: 'text-green-800 dark:text-green-200',
        message: 'text-green-700 dark:text-green-300'
    },
    error: {
        base: 'bg-red-50 border-red-200 dark:bg-red-900/40 dark:border-red-900/30',
        icon: 'text-red-500 dark:text-red-400',
        title: 'text-red-800 dark:text-red-200',
        message: 'text-red-700 dark:text-red-300'
    },
    warning: {
        base: 'bg-yellow-50 border-yellow-200 dark:bg-yellow-900/40 dark:border-yellow-900/30',
        icon: 'text-yellow-500 dark:text-yellow-400',
        title: 'text-yellow-800 dark:text-yellow-200',
        message: 'text-yellow-700 dark:text-yellow-300'
    },
    info: {
        base: 'bg-blue-50 border-blue-200 dark:bg-blue-900/40 dark:border-blue-900/30',
        icon: 'text-blue-500 dark:text-blue-400',
        title: 'text-blue-800 dark:text-blue-200',
        message: 'text-blue-700 dark:text-blue-300'
    }
};